import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getParticularAdminDashboardAPI = createAsyncThunk(
  "auth/AdminDashboard/getPaticular",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.adminAction("dashboard",0)
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getparticularDetailsAdminDashboardSlice = createSlice({
  name: "get particular AdminDashboard",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetgetparticularAdminDashboard: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getParticularAdminDashboardAPI.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getParticularAdminDashboardAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getParticularAdminDashboardAPI.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetgetparticularAdminDashboard } = getparticularDetailsAdminDashboardSlice.actions;
export const getparticularDetailsAdminDashboardReducer =
  getparticularDetailsAdminDashboardSlice.reducer;
